
const digest = 'f27612d0eaa00e1815ca40f5849ce83bfb45989e4f2bfd51d09306780a1c1bee';
const classes = {"wrapper":"_wrapper_n090l_1"};
const css = `._wrapper_n090l_1 {
  background: #ceddf5;
  margin: -34px -24px;
  padding: 30px;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  